import type { MouseEvent } from "react";

/**
 * Where to send the user if the CMP cannot be reached. This site has no on-site
 * cookie-policy route, so the fallback is Bumble's hosted policy. Callers
 * normally pass the URL from the DatoCMS footer link itself, so this default is
 * only a safety net.
 */
export const DEFAULT_COOKIE_POLICY_FALLBACK = "https://www.bumble.com/cookie-policy";

/**
 * Opens the SourcePoint privacy manager, falling back to the cookie policy.
 *
 * The fallback matters more than it looks: it is what users hit when
 * SourcePoint is blocked, which is disproportionately the privacy tooling of
 * people who most want to manage their cookies. Navigating somewhere useful
 * beats a link that silently does nothing.
 */
export function openPrivacyManager(event: MouseEvent<HTMLAnchorElement>, fallbackUrl: string = DEFAULT_COOKIE_POLICY_FALLBACK): void {
  event.preventDefault();
  const gdpr = window._sp_?.gdpr;
  if (gdpr) {
    try {
      gdpr.loadPrivacyManagerModal();
      return;
    } catch {
      // CMP present but the modal failed to open — fall through to the policy.
    }
  }
  window.location.href = fallbackUrl;
}